export const esES = {
	translation: {
		//PÁGINA DE LOGIN
		//header
		'login-header': 'Bienvenido!',
		//login CTA
		'login-cta': 'Inicia sesión para acceder a nuestra plataforma!',
		//login question
		'login-question': '¿No tienes una cuenta?',
		//login plans CTA
		'login-plans-cta': 'Haz clic en el botón de abajo para ver nuestros planes:',
		//login button
		'login-button-plans': 'VER PLANES',
		//login e-mail field
		'login-email': 'correo electrónico',
		//login e-mail password
		'login-password': 'contraseña',
		//login button access
		'login-button-access': 'ENTRAR',
		//login button forgot password
		'login-button-forgot-password': '¿Olvidaste tu contraseña?',

		//HEADER DE GRUPOS
		//group-welcome
		'group-welcome': 'Bienvenido',
		//group-intro
		'group-intro': '¡Has iniciado sesión como',
		//group-admin
		'group-admin': 'Administrador!',
		//group-user
		'group-user': 'Usuario!',
		//group-header
		'group-header': 'GRUPOS',
		//group-button
		'group-button': 'NUEVO GRUPO',

		//GRUPOS LISTA
		//group-list-header
		'group-list-header': 'Ver Grupos',
		//group-list-title
		'group-list-intro': 'PROYECTOS',
		//group-list-button
		'group-list-button': 'NUEVO PROYECTO',
		//group-searchbar
		'group-searchbar': 'Buscar aquí...',
		//group-no-projects
		'group-no-projects': '¡Este grupo no tiene ningún proyecto vinculado! 😢',
		'group-duplicate': '¿Desea duplicar este grupo?',
		'group-duplicate-description': 'Esta acción copiará el grupo y sus respectivos proyectos.',

		//GRUPOS ITENS DA TABELA
		//group-table-title
		'group-table-title': 'TÍTULO',
		//group-table-description
		'group-table-description': 'DESCRIPCIÓN',
		//group-table-manager
		'group-table-manager': 'GERENTE',
		//group-table-actions
		'group-table-actions': 'ACCIONES',
		//group-table-action-download
		'group-table-action-download': 'Descargar CSV',
		//group-table-action-duplicate
		'group-table-action-duplicate': 'Duplicar',
		//group-table-action-edit
		'group-table-action-edit': 'Editar',
		//group-table-action-delete
		'group-table-action-delete': 'Bprrar',
		//group-table-action-answers
		'group-table-action-answers': 'Registros',
		//group-table-action-access
		'group-table-action-access': 'Accessar',

		//DOWNLOAD CSV MODAL
		'initial-date': 'Fecha Inicio',
		'final-date': 'Fecha Final',
		'generate-excel': 'Generar',

		//GRUPOS PÁGINA
		//group-char-min
		'group-char-min': 'El valor debe contener al menos 4 caracteres.',
		//group-char-max
		'group-char-max': 'El valor debe contener un máximo de 20 caracteres.',
		//group-char-required
		'group-char-required':
			'Por favor, complete el campo correctamente. El campo debe tener entre 4-20 caracteres.',
		//group-page-view
		'group-page-view': 'Ver Grupos',
		//group-page-header
		'group-page-header': 'GRUPO',
		//group-page-title
		'group-page-title': 'TÍTULO',
		//group-page-manager
		'group-page-manager': 'GERENTE',
		//group-page-button
		'group-page-button': 'GUARDAR',
		//group-page-edit
		'group-page-edit': 'EDITAR GRUPO',
		//group-page-edit-title
		'group-page-edit-title': 'Título',
		//group-page-edit-manager
		'group-page-edit-manager': 'Gerente',

		//PÁGINA DE PROYECTOS
		//projects-page-view
		'projects-page-view': 'VER PROYECTOS',
		//projects-page-header
		'projects-page-header': 'PROYECTO',
		//projects-page-edit
		'projects-page-edit': 'EDITAR PROYECTO',

		//PROJECTS EDIT PAGE
		//projects-edit-title
		'projects-edit-title': 'Título',
		//projects-edit-description
		'projects-edit-description': 'Descripción',
		//projects-edit-manager
		'projects-edit-manager': 'Gerente',
		'project-edit-toast': '¡Proyecto editado exitosamente!',

		//ITENS DA TABELA DE PROJETOS
		//projects-table-title
		'projects-table-title': 'Título',
		//projects-table-description
		'projects-table-description': 'Descripción',
		//projects-table-placeholder
		'projects-table-placeholder': 'ex: Proyecto de estudios',
		//projects-table-status
		'projects-table-status': 'Status',
		//projects-table-active
		'projects-table-active': 'Activo',
		//projects-table-manager
		'projects-table-manager': 'Gerente',
		//projects-table-owner-email
		'projects-table-email-placeholder': 'ex: sue-mail@e-mail.com',
		//projects-table-save
		'projects-table-save': 'GUARDAR',
		'project-duplicate': '¿Desea duplicar este proyecto',
		'project-duplicate-description': 'Esta acción duplicará el proyecto y sus campos relacionados.',
		'project-duplicate-destination-title': '¿Para qué grupo desea duplicar este proyecto?',

		//PÁGINA DE FORMULÁRIOS DE PROJETOS
		//projects-forms-warning
		'projects-forms-warning': 'Este proyecto no tiene ningún registro. 😢',
		//projects-forms-text
		'projects-forms-text': 'TEXTO',
		//projects-forms-label
		'projects-forms-label': 'LABEL',
		//projects-forms-number
		'projects-forms-number': 'NUMÉRICO',
		//projects-forms-dropdown
		'projects-forms-dropdown': 'DROPDOWN',
		//projects-forms-checkbox
		'projects-forms-checkbox': 'CHECKBOX',
		//projects-forms-radio
		'projects-forms-radio': 'RADIO',
		//projects-forms-counter
		'projects-forms-counter': 'CONTADOR',
		//projects-forms-date
		'projects-forms-date': 'FECHA/HORA',
		//projects-forms-image
		'projects-forms-image': 'FOTO/IMAGEN',
		'projects-forms-coordenates': 'COORDENADAS',
		//projects-forms-sort-button
		'projects-forms-sort-button': 'ORDENAR CAMPOS',
		//projects-forms-records-button
		'projects-forms-records-button': 'REGISTROS',
		//projects-forms-records-title
		'projects-forms-records-title': 'Título',
		//projects-forms-records-description
		'projects-forms-records-description': 'Descripción',
		//projects-forms-records-type
		'projects-forms-records-type': 'Tipo',
		//projects-forms-records-manager
		'projects-forms-records-manager': 'Gerente',
		//projects-forms-records-order
		'projects-forms-records-order': 'Orden',
		//projects-forms-records-actions
		'projects-forms-records-actions': 'Acciones',

		//PROJECT-RECORDS-TABLE
		//project-records-saved
		'project-records-saved': 'REGISTROS',
		//project-records-responsible
		'project-records-responsible': 'Responsable',
		//project-records-latitude
		'project-records-latitude': 'Latitud',
		//project-records-longitude
		'project-records-longitude': 'Longitud',
		//project-records-date
		'project-records-date': 'Fecha',
		//project-records-actions
		'project-records-actions': 'Acciones',
		//project-records-answers
		'project-records-answers': 'Respuestas',
		//project-records-error
		'project-records-error': '¡Este proyecto no tiene ningún registro guardado! 😢',
		//project-records-answers-title
		'project-records-answers-title': 'RESPUESTAS',
		'project-records-generate-pdf': 'Generar informe pendiente (PDF)',
		'project-records-no-pendencies': 'No hay elementos pendientes para generar informe',

		//GENERAL-ERRORS
		//invalid-email
		'invalid-email': '¡Correo electrónico inválido!',
		//empty-field
		'empty-field': '¡Por favor, complete el campo!',
		//forgot-password-warning
		'forgot-password-warning': '¡Por favor, contacta a tu supervisor!',
		//wrong-email-password
		'wrong-email-password': '¡Correo electrónico y/o contraseña incorrectos!',

		//GENERAL-INFOS
		//options-field-requisition
		'options-field-requisition': 'Por favor, complete el campo con al menos una opción.',
		//options-field-empty
		'options-field-empty': 'Por favor, inserte un valor en el campo de Opciones.',
		//insert-value-placeholder
		'insert-value-placeholder': 'Inserte un valor',
		//write-text-placeholder
		'write-text-placeholder': 'Escribe el texto aquí...',
		//title-placeholder
		'title-placeholder': 'ex: Título',
		//button-project-field-name
		'button-project-field-name': 'Nombre del Campo',
		//button-project-field-description
		'button-project-field-description': 'Descripción',
		//button-project-field-manager
		'button-project-field-manager': 'Gerente',
		//button-project-field-options
		'button-project-field-options': 'Opciones',
		//obligatory-field
		'obligatory-field': 'Campo obligatorio',
		//go-back-button
		'go-back-button': 'Volver',
		//loading-warning
		loading: 'Cargando...',
		//delete-option-contract
		'delete-option-contract': '¿Realmente deseas eliminar',
		//delete-verification-contract
		'delete-verification-contract': 'Cuando se confirme, el grupo será eliminado.',
		//delete-option-project
		'delete-option-project': '¿Realmente deseas eliminar',
		//delete-verification-project
		'delete-verification-project': 'Cuando se confirme, el proyecto será eliminado.',
		//delete-option-field
		'delete-option-field': '¿Realmente desea eliminar el campo?',
		//delete-verification-field
		'delete-verification-field': 'Cuando se confirme, el campo "{{fieldRowTitle}}" se eliminará.',
		//delete-option-field-option
		'delete-option-field-option': '¿Realmente deseas eliminar la opción de campo?',
		//delete-verification-field-option
		'delete-verification-field-option':
			'Cuando se confirme, la opción "{{fieldOptionIdToDeleteTitle}}" será eliminada.',
		//field-delete-button
		'field-delete-button': 'ELIMINAR',
		//field-cancel-button
		'field-cancel-button': 'CANCELAR',
		//image-button-return
		'image-button-return': 'VOLVER',
		//image-button-next
		'image-button-next': 'SIGUIENTE',
		//drag-and-drop-alert
		'drag-and-drop-alert': 'Por favor, seleccione un archivo CSV.',
		//drag-and-drop-selected
		'drag-and-drop-selected': '¡Archivo seleccionado! 🚀',
		//drag-and-drop-manual
		'drag-and-drop-manual':
			'Arrastra y suelta un archivo CSV o haz clic para seleccionar uno manualmente.',
		//new-field-title-header
		'new-field-title': 'NUEVO CAMPO',
		//new-field-dropdown-header
		'new-field-dropdown': 'NUEVO DROPDOWN',
		//new-field-checkbox-header
		'new-field-checkbox': 'NUEVO CHECKBOX',
		//new-field-radio-header
		'new-field-radio': 'NUEVO RADIO',
		//new-field-counter-header
		'new-field-counter': 'NUEVO CONTADOR',
		//new-field-image-header
		'new-field-image': 'NUEVA IMAGEN',
		//sort-fields-button
		'sort-fields-button': 'ORDENAR CAMPOS',
		//sidebar-group-button
		'sidebar-group-button': 'Grupos',
		'sidebar-group-access': 'Control de Acceso',
		'sidebar-manage-users': 'Gestion de Usuarios',

		//HEADERS-NEW-FIELDS
		//new-field-title
		'new-field-header': 'NUEVO CAMPO',
		//new-checkbox-header
		'new-checkbox-header': 'NUEVO CHECKBOX',
		//new-radio-header
		'new-radio-header': 'NUEVO RADIO',
		//new-dropdown-header
		'new-dropdown-header': 'NUEVO DROPDOWN',
		//new-counter-header
		'new-counter-header': 'NUEVO CONTADOR',
		//new-image-header
		'new-image-header': 'NUEVA IMAGEN',

		//FIELDS-TEXTS
		//field-name
		'field-name': 'Nombre del Campo',
		//field-name-placeholder
		'field-name-placeholder': 'ex: Título',
		//field-description
		'field-description': 'Descripción del Campo',
		//field-description-placeholder
		'field-description-placeholder': 'ex: Escribe el texto...',
		//field-manager
		'field-manager': 'Gerente',
		//field-option
		'field-option': 'Opción',
		//field-option-placeholder
		'field-option-placeholder': 'Inserte un valor',
		//field-update-button
		'field-update-button': 'ACTUALIZAR',
		//field-csv-error
		'field-csv-error': 'ERROR AL CARGAR CSV',
		//csv-limit-field-options
		'csv-limit-field-options': 'Número excedido de opciones de campo - MÁXIMO: 50 campos',

		//PROJECT-FIELDS
		//project-fields-title
		'project-fields-title': 'Título',
		//project-fields-description
		'project-fields-description': 'Descripción',
		//project-fields-type
		'project-fields-type': 'Tipo',
		//project-fields-manager
		'project-fields-manager': 'Gerente',
		//project-fields-order
		'project-fields-order': 'Orden',
		//project-fields-actions
		'project-fields-actions': 'Acciones',

		//PROJECT-FIELDS-IDS
		//project-fields-id-title
		'project-fields-id-checkbox': 'Checkbox',
		//project-fields-id-text
		'project-fields-id-text': 'Texto',
		//project-fields-id-dropdown
		'project-fields-id-dropdown': 'Dropdown',
		//project-fields-id-radio
		'project-fields-id-radio': 'Radio',
		//project-fields-id-image
		'project-fields-id-image': 'Imagen',
		//project-fields-id-counter
		'project-fields-id-counter': 'Contador',
		//project-fields-id-date
		'project-fields-id-date': 'Fecha/Hora',
		//project-fields-id-edit
		'project-fields-id-edit': 'Editar',
		//project-fields-id-delete
		'project-fields-id-delete': 'Eliminar',
		//project-fields-warning
		'project-fields-warning': 'Este proyecto no tiene ningún campo. 😢',

		//CounterFieldSchema
		//counter-field-max
		'counter-field-max': 'El valor debe contener un máximo de 100 caracteres.',
		//counter-field-min
		'counter-field-min': 'El valor debe contener al menos 4 caracteres.',
		//counter-field-required
		'counter-field-required':
			'Por favor, complete el campo correctamente. El campo debe tener entre 4-100 caracteres.',

		// Only Admin
		'admin-only': '¡Área exclusiva para administradores!',

		//Dashboard
		'create-chart-modal-title': 'Crear Gráfico',
		'remove-chart-modal-title': 'Eliminar Gráfico',
		'remove-chart-modal-subtitle': '¿Quieres eliminar el gráfico seleccionado?',
		'dashboard-select-values-instruction': 'Para continuar, seleccione el grupo y el proyecto.',
		'select-group': 'Seleccionar el grupo',
		'select-project': 'Seleccionar el proyecto',
		'select-field': 'Seleccionar el campo',
		'user-log-analysis': 'Análisis del registro de usuarios',
		'check-answers': 'Ver respuestas',
		'view-image': 'Ver imagen',
		'filter-by-owner-id': 'Filtrar por usuario',
		'want-remove-the-filter': '¿Quieres eliminar el filtro?',
		'no-map-records': '¡No se encontraron registros en el filtro!',
		'asc-filter': 'Ascendente',
		'desc-filter': 'Descendente',
		'ordering-filter': 'Ordenación',
		'general-chart-option': 'Gráfico general',
		'group-data-chart-option': 'Relacionar datos',
		'group-data-chart-remove': 'Eliminar',
		'group-data-chart-add-relation': 'Agregar',
		'select-field-option': 'Seleccionar opción',
		'related-by': 'Agrupar por:',
		'filters-applied': 'Filtros aplicados:',

		// Grid Locale
		'grid-locale-page': 'Página',
		'grid-locale-more': 'Más',
		'grid-locale-to': 'a',
		'grid-locale-of': 'de',
		'grid-locale-next': 'Siguiente',
		'grid-locale-last': 'Último',
		'grid-locale-first': 'Primero',
		'grid-locale-previous': 'Anterior',
		'grid-locale-filterOoo': 'Filtrar...',
		'grid-locale-equals': 'Igual a',
		'grid-locale-notEqual': 'Diferente de',
		'grid-locale-lessThan': 'Menor que',
		'grid-locale-greaterThan': 'Mayor que',
		'grid-locale-lessThanOrEqual': 'Menor o igual a',
		'grid-locale-greaterThanOrEqual': 'Mayor o igual a',
		'grid-locale-inRange': 'Entre',
		'grid-locale-contains': 'Contiene',
		'grid-locale-notContains': 'No contiene',
		'grid-locale-startsWith': 'Empieza con',
		'grid-locale-endsWith': 'Termina con',
		'grid-locale-dateFormatOoo': 'dd/mm/yyyy',
		'grid-locale-numberFilterOoo': 'Filtrar por número...',
		'grid-locale-textFilterOoo': 'Filtrar por texto...',
		'grid-locale-applyFilter': 'Aplicar filtro',
		'grid-locale-clearFilter': 'Limpiar filtro',
		'grid-locale-loadingOoo': 'Cargando...',
		'grid-locale-noRowsToShow': 'No se encontraron registros',
		'grid-locale-selectAll': 'Seleccionar todo',
		'grid-locale-searchOoo': 'Buscar...',
		'grid-locale-blanks': 'Vacíos',
		'grid-locale-group': 'Grupo',
		'grid-locale-columns': 'Columnas',
		'grid-locale-filters': 'Filtros',
		'grid-locale-rowGroupColumnsEmptyMessage': 'Arrastra columnas aquí para agrupar',
		'grid-locale-valueColumnsEmptyMessage': 'Arrastra columnas aquí para agregar',
		'grid-locale-pinColumn': 'Fijar columna',
		'grid-locale-autosizeThiscolumn': 'Ajustar esta columna',
		'grid-locale-autosizeAllColumns': 'Ajustar todas las columnas',
		'grid-locale-resetColumns': 'Restablecer columnas',
		'grid-locale-expandAll': 'Expandir todo',
		'grid-locale-collapseAll': 'Colapsar todo',

		// Access Control
		'select-user': 'Seleccionar el usuario',
		'click-select-user': 'Haga clic a continuación para listar usuarios',
		'not-found-user': 'Usuario no encontrado',
		'org-without-groups': '¡Una organización sin ningún grupo creado!',
		'org-without-projects': '¡Un grupo sin ningún proyecto creado!',

		// Generic Error
		'generic-error': 'Se produjo un error....',

		// Manage
		'user-created': 'Usuario creado exitosamente!',
		'user-deleted': 'Usuario eliminado exitosamente!',
		'user-edited': 'Usuario editado exitosamente!',
		'add-user': 'Agregar usuario',
		'col-name': 'Nombre',
		'col-email': 'Correo electrónico',
		'col-role': 'Rol',
		'col-created-at': 'Fecha de creación',
		'col-actions': 'Acciones',
		'row-admin-role': 'Administrador',
		'row-user-role': 'Usuario',
		'insert-value': 'Ingrese el valor...',
		'modal-password': 'Contraseña',
		'modal-new-user': 'Nuevo Usuario',
		'modal-edit-user': 'Editar Usuario',
		'modal-delete-user': 'Eliminar usuario',
		'modal-delete-info': '¿Realmente desea eliminar el usuario?',
		'modal-reset-password-info':
			'Si no desea cambiar la contraseña del usuario, deje el campo en blanco.',
		'modal-reset-password-label': 'Restablecer contraseña',
		'modal-reset-password-warning':
			'Al restablecer la contraseña del usuario, la contraseña predeterminada será "Handler@1234".',
		'validation-name-min': 'El nombre debe tener al menos 2 caracteres',
		'validation-email-invalid': 'Correo electrónico inválido',
		'validation-password-min': 'La contraseña debe tener al menos 6 caracteres',
		'validation-role-min': 'Seleccione un rol válido',

		// Answer Page
		'request-changes': 'Solicitar cambios',
		'see-pendencies': 'Ver elementos pendientes',
		'pendency-description': 'Descripción del elemento pendiente',
		'record-pendency': 'Elemento de registro pendiente',
		'proyecto-sin-registros': 'Este proyecto no tiene registros. 😢',

		// Pendency Card
		'pendency-card-description': 'Descripción',
		'pendency-card-status': 'Estado',
		'pendency-card-owner': 'Solicitante',
		'pendency-card-created-at': 'Fecha de creación',
		'pendency-card-updated-at': 'Fecha de cambio',
		'pendency-resolved': 'Resuelto',
		'pendency-unresolved': 'Sin resolver',
		'corrección de pendencia': 'Corrección',
		'see-correction': 'Ver corrección',
		'edit-pendency': 'Edición pendiente',
		'delete-pendency': 'Eliminar elemento pendiente',
		'delete-confirm-description': 'Tras la confirmación, el elemento pendiente se eliminará',

		// Correction Page
		'validate-correction': 'Validar corrección',
		'validate-correction-description':
			'Tras la confirmación, la corrección se marcará como resuelta.',
		'corrección-creada-con éxito': 'Solicitação de correção criada com sucesso!',
		'correction-already-exists': 'Ya existe una respuesta validada como corrección.',

		'attachment-image': 'Adjuntar imagen',
		'upload-text': 'Haga clic o arrastre el archivo a esta área para subirlo',
		'upload-hint':
			'Se permite una sola subida. Está estrictamente prohibido subir datos de la empresa u otros archivos prohibidos',

		'pendency-report_file': 'informe_de_pendencia_{{recordId}}.pdf'
	}
};
